import { Component, OnInit } from '@angular/core';
import { EntityDirectoryService } from './entity-directory.service';
import { Router } from '@angular/router';
import { prefix } from '../../constants';
import { Policies } from '../../../shared/constants';
import { PoliciesService } from '../../../shared/services';
import { Options } from '../../models/options';

@Component({
  selector: 'entity-directory',
  templateUrl: './entity-directory.component.html',
  styleUrls: ['./entity-directory.component.scss']
})
export class EntityDirectoryComponent implements OnInit {
  getEntitiesPolicy: string[] = [Policies.GET_ENTITIES];

  // These are the columns of the table.
  entityColumns: Object = {
    code: {
      name: 'Entity Code',
      searchable: true
    },
    name: 'Entity Full Name',
    domicileCode: {
      name: 'Domicile',
      searchable: true
    },
    taxCode: 'Tax Jurisdiction',
    primaryFunctionName: {
      name: 'Primary Function',
      searchable: true
    },
    fiscalYearEnd: 'Fiscal Year End'
  };

  // These are manifested as the table options you can click on.
  options: Array<Options> = [{
    name: 'Dashboard',
    value: 'dashboard',
    policies: this.getEntitiesPolicy
  }, {
    name: 'Repository',
    value: 'repository',
    policies: this.getEntitiesPolicy

  }, {
    name: 'Transactions',
    value: 'transactions',
    policies: this.getEntitiesPolicy
  }];

  views = [{
    name: 'Entity List',
    id: 'list',
    isActive: true,
    src: 'legacy/assets/img/v2-icons/List.svg'
  }, {
    name: 'Entity Hierarchy',
    id: 'hierarchy',
    src: 'legacy/assets/img/v2-icons/Chart.svg'
  }];

  constructor(private _router: Router,
    public service: EntityDirectoryService,
    private _userPoliciesService: PoliciesService) { }

  ngOnInit() {
    this._userPoliciesService.getUserPolicies().subscribe((policies) => {
      let updatedOptions = [];
      this.options.forEach((option: Options) => {
        const update = (option.policies && policies.some(userPolicy => option.policies.includes(userPolicy.policyName)));
        if (update) {
          updatedOptions.push(option);
        }
      });
      this.options = updatedOptions;
    });
  }

  /**
   * This gets the entities from the service, and properly maps the values to
   * what row values are called for by the table columns.
   */
  getEntities() {
    const entities = [];
    for (let ent of this.service.entities) {
      const entity = ent as any;
      entity.domicileCode = entity.domicile.isoCode;
      entity.taxCode = entity.taxJurisdiction.isoCode;
      entity.primaryFunctionName = entity.primaryFunction.name;
      entities.push(entity);
    }
    return entities;
  }

  /**
   * Callback that is called once a row option is clicked.
   */
  handleRowSelect(event) {
    this._router.navigate([`/${prefix}/entity/${event.row.entityId}/${event.option}`]);
  }
}
